export default __webpack_public_path__ + "static/media/ecom3.e8d8423c.jpeg";